import * as React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import Main from './layout/Main';
import { withTransition } from 'bpm-web-generic';
import Popup from './components/views/Popup';
import { Session, SubscriptionInfo } from 'bpm-client-api';
import { Environment } from './env';
class App extends React.Component {

    constructor(props: any) {
        super(props);
        Session.setUnauthorizedHandler((err) => {
            let path = location.pathname.split('/').map(encodeURIComponent).join('/')
            if (location.search) {
                path += location.search
            }
            window.location.assign(Environment.POOL_URL + '/login?platform=supreme&pool_redirect=' + path);
        })
        Session.setSubscriptionHandler((err) => {
            if (err.current_supscription == SubscriptionInfo.None) {
                Popup.subscribe().then(result => {
                    if (result == 'ok') {
                        window.location.assign('/subscribe')
                    } else {
                        if (location.pathname.includes('download-history') || location.pathname.includes('playlists/') || location.pathname.includes('curated-sets/'))
                            history.back()
                    }
                })
            } else {
                Popup.upgrade().then(result => {
                    if (result == 'ok') {
                        window.location.assign('/upgrade')
                    } else {
                        if (location.pathname.includes('download-history') || location.pathname.includes('playlists/') || location.pathname.includes('curated-sets/'))
                            history.back()
                    }
                })
            }
        })
        Session.setUserNotVerifiedHandler((error) => {
            Popup.notVerified(error.submission_pending, error.is_declined).then((result) => {
                if (result == 'ok' && error.submission_pending) {
                    window.location.assign(Environment.POOL_URL + '/membership-request');
                } else {
                    if (location.pathname.includes('download-history') || location.pathname.includes('playlists/') || location.pathname.includes('curated-sets/'))
                        history.back()
                }
            })
        })
    }

    render() {
        return (<>
            <Popup />
            <BrowserRouter>
                <Switch>
                    <Route path='/:page' component={withTransition(Main)} />
                    <Route render={() => {
                        return <Redirect to={'/browse' + location.search} />
                    }} />
                </Switch>
            </BrowserRouter>
        </>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx